import { Component, OnDestroy, OnInit } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { ConfigService } from '../shared/config';
import { NotificationService } from '../shared/notification.service';
import { Subscription } from 'rxjs';
import { CompanyUserService } from '../admin-setting/assing-company-users/company-user.service';

interface CompanySettingsForm {
  name: string;
  isApplePayActive: boolean;
  isCardActiveOverAll: boolean;
  isGooglePayActive: boolean;
  isVippsGlobalActive: boolean;
  overrideColor: boolean;
  overrideWindowMessage: boolean;
  textColor: string;
  themeColor: string;
  windowColor: string;
  windowMessage: string;
}

import moment from  'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.css']
})
export class SettingComponent implements OnInit, OnDestroy {  ref;
  task;
  uploadProgress;
  uploadURL;
  companyId: string = null;
  isLoading = true;
  isSaving = false;
  companyNotFound = false;
  companySettings: CompanySettingsForm = this.getDefaultSettings();
  private companySubscription = new Subscription();

  constructor(public afStorage: AngularFireStorage,
    private afs : AngularFirestore,
    private config:ConfigService,
    private companyUserService: CompanyUserService,
    private notificationService: NotificationService)  { }

  ngOnInit() {
    this.loadCompanySettings();
  }

  ngOnDestroy() {
    this.companySubscription.unsubscribe();
  }

  upload(event) {
      const file = event.target.files[0];
      const filePath = "gdpr_"+ new Date().toJSON().slice(0,10);
      const task = this.afStorage.upload(filePath, file).then(() => {
           const ref = this.afStorage.ref(filePath);
          this. uploadURL = ref.getDownloadURL()
          this. uploadURL.subscribe(url => { 
           console.log(url);
           if(url){
             this.afs.collection('company').doc(this.config.getCompanyId()).update({logoUrl:url,updatedOn:moment().unix()});
           }
       })
    })
  }

  saveCompanySettings() {
    if (!this.companyId || this.isSaving) {
      return;
    }

    this.isSaving = true;
    const payload = {
      name: this.companySettings.name ? this.companySettings.name.trim() : '',
      isApplePayActive: this.companySettings.isApplePayActive,
      isCardActiveOverAll: this.companySettings.isCardActiveOverAll,
      isGooglePayActive: this.companySettings.isGooglePayActive,
      isVippsGlobalActive: this.companySettings.isVippsGlobalActive,
      overrideColor: this.companySettings.overrideColor,
      overrideWindowMessage: this.companySettings.overrideWindowMessage,
      textColor: this.companySettings.textColor ? this.companySettings.textColor.trim() : '',
      themeColor: this.companySettings.themeColor ? this.companySettings.themeColor.trim() : '',
      windowColor: this.companySettings.windowColor ? this.companySettings.windowColor.trim() : '',
      windowMessage: this.companySettings.windowMessage ? this.companySettings.windowMessage.trim() : ''
    };

    this.companyUserService.updateCompany(this.companyId, payload)
      .finally(() => {
        this.isSaving = false;
      });
  }

  reloadCompanySettings() {
    this.companySubscription.unsubscribe();
    this.companySubscription = new Subscription();
    this.loadCompanySettings();
  }

  private loadCompanySettings() {
    this.companyId = this.config.getCompanyId();
    this.companyNotFound = false;

    if (!this.companyId) {
      this.isLoading = false;
      this.companyNotFound = true;
      this.companySettings = this.getDefaultSettings();
      return;
    }

    this.isLoading = true;
    this.companySubscription = this.companyUserService.getCompanyById$(this.companyId).subscribe(company => {
      this.isLoading = false;

      if (!company) {
        this.companyNotFound = true;
        this.companySettings = this.getDefaultSettings();
        return;
      }

      this.companySettings = this.getSettingsFromCompany(company);
    });
  }

  private getDefaultSettings(): CompanySettingsForm {
    return {
      name: '',
      isApplePayActive: true,
      isCardActiveOverAll: true,
      isGooglePayActive: true,
      isVippsGlobalActive: true,
      overrideColor: true,
      overrideWindowMessage: false,
      textColor: 'white',
      themeColor: '#2d2926',
      windowColor: '#11960c',
      windowMessage: 'OBS. Ta ut sausebeger fra stekt ris og kylling for du varmer retten'
    };
  }

  private getSettingsFromCompany(company): CompanySettingsForm {
    const defaultSettings = this.getDefaultSettings();

    return {
      name: company['name'] || defaultSettings.name,
      isApplePayActive: typeof company['isApplePayActive'] === 'boolean' ? company['isApplePayActive'] : defaultSettings.isApplePayActive,
      isCardActiveOverAll: typeof company['isCardActiveOverAll'] === 'boolean' ? company['isCardActiveOverAll'] : defaultSettings.isCardActiveOverAll,
      isGooglePayActive: typeof company['isGooglePayActive'] === 'boolean' ? company['isGooglePayActive'] : defaultSettings.isGooglePayActive,
      isVippsGlobalActive: typeof company['isVippsGlobalActive'] === 'boolean' ? company['isVippsGlobalActive'] : defaultSettings.isVippsGlobalActive,
      overrideColor: typeof company['overrideColor'] === 'boolean' ? company['overrideColor'] : defaultSettings.overrideColor,
      overrideWindowMessage: typeof company['overrideWindowMessage'] === 'boolean' ? company['overrideWindowMessage'] : defaultSettings.overrideWindowMessage,
      textColor: company['textColor'] || defaultSettings.textColor,
      themeColor: company['themeColor'] || defaultSettings.themeColor,
      windowColor: company['windowColor'] || defaultSettings.windowColor,
      windowMessage: company['windowMessage'] || defaultSettings.windowMessage
    };
  }
}
